module.exports = __webpack_public_path__ + "static/media/flowImg.49e92beb.png";